import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import PropTypes from 'prop-types'
import ColorHash from 'color-hash'
import pluralize from 'pluralize'
import { Button, Modal } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const backgroundHash = new ColorHash({
  saturation: 0.7,
  lightness: 0.95,
})

const borderHash = new ColorHash({
  saturation: 0.8,
  lightness: 0.85,
})

/* eslint-disable-next-line */
const DeterministicPill = ({ reference }) => (
  <span
    className={cx('deterministic-pill')}
    style={{
      backgroundColor: backgroundHash.hex(reference),
      borderColor: borderHash.hex(reference),
    }}
  >
    {reference}
  </span>
)

const PresenceModal = ({ members = [] }) => {
  const groupedMembers = _(members)
    .groupBy('identity.__typename')
    .mapValues(vals =>
      vals.sort((a, b) => moment(b.last_updated_at).isBefore(a.last_updated_at))
    )
    .value()

  const AuthenticatedMemberList = ({ members = [] }) => {
    if (!members.length) return null

    return members.map((m, i) => (
      <section
        key={m.identity.__typename + '_' + i}
        className={cx('presence-member-row')}
      >
        <section className={cx('presence-member-row-identity')}>
          <h4 className={cx('presence-member-row-name')}>
            {m.identity.first_name} {m.identity.last_name}
          </h4>
          <div className={cx('presence-member-row-connection-time')}>
            Last updated {moment(m.last_updated_at).fromNow()}
          </div>
        </section>
        <section className={cx('presence-member-row-context-summary')}>
          <DeterministicPill
            reference={_.get(m.context, 'action') || 'unknown'}
          />
        </section>
      </section>
    ))
  }

  const AnonymousMemberList = ({ members = [] }) => {
    if (!members.length) return null

    return members.map((m, i) => (
      <section
        key={m.identity.__typename + '_' + i}
        className={cx('presence-member-row')}
      >
        <section className={cx('presence-member-row-identity')}>
          <h4 className={cx('presence-member-row-name')}>
            Anonymous ({_.last(m.connection_id.split('-'))})
          </h4>
          <section className={cx('presence-member-row-connection-time')}>
            Last updated {moment(m.last_updated_at).fromNow()}
          </section>
        </section>
        <section className={cx('presence-member-row-context-summary')}>
          <DeterministicPill
            reference={_.get(m.context, 'action') || 'unknown'}
          />
        </section>
      </section>
    ))
  }

  return (
    <Modal
      title='Active watchers on this page'
      className={cx('presence-members-modal')}
      trigger={
        <Button className={cx('watcher-count')} role='navigation'>
          <a>
            {members.length} active {pluralize('watcher', members.length)}
          </a>
        </Button>
      }
    >
      <Modal.Content>
        <AuthenticatedMemberList members={groupedMembers.AuthenticatedMember} />
        {/* We haven't used this in a place that support anonymous members yet, so this is incomplete */}
        <AnonymousMemberList members={groupedMembers.AnonymousMember} />
      </Modal.Content>
    </Modal>
  )
}

PresenceModal.propTypes = {
  members: PropTypes.array,
}

export default PresenceModal
